

import { useState, useEffect } from "react";
import MKTypography from "components/MKTypography"; 
 
import MKInput from "components/MKInput";
import Divider from "@mui/material/Divider";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import { appAuth } from "../../contexts/AppContext"
 

export default function AppGroup({group, app, onSuccess, dismiss}) { 

    const {createAppGroup, updateAppGroup} =  appAuth()
    const [message, setMessage] = useState("")
    const [error, setErrorMessage] = useState("")
    const [data, setData] = useState({})

    useEffect(() => {
       setData({appId: app.appId, 
            groupId: group ? group.groupId : null, 
            name: group ? group.name : "",
            desc: group ? group.desc : "",
            status: group ? group.status : "active",
       })
    }, [])

    const onChangeInput = (evt) => { 

        setData({
            ...data,
            [evt.target.name]: evt.target.value,
        });
    }


    const onKeyEnterDown = (event) => {
        if(event.keyCode == 13) submitGroup()
    }

    const submitGroup = async () => {
        setErrorMessage("")
        setMessage("") 

        if(!data.name) {
            setErrorMessage("Please enter all fields") 
            return;
        }
        if(data.groupId) {
            let result = await updateAppGroup(data)
            
            if (!result || result.error) {
                setErrorMessage(result.error.message) 
                return;
            } 
            
            onSuccess(result)
            return;
        }

        let result = await createAppGroup(data)
        
        if (result.error) {
            setErrorMessage(result.error.message) 
            return;
        } 
        
        onSuccess(result)
         

    }
 
    return(

    <MKBox>
        
        {error && <MKTypography variant="button" color="error" px={2}>{error}</MKTypography> }
        {message && <MKTypography variant="body2" color="info" px={2}>{message}</MKTypography>}
        <Divider sx={{ my: 0 }} />
       
        <MKBox p={2}>
             
            <MKBox py={2} mb={2}>

                <MKInput
                    id="name"
                    variant="standard"
                    label="Name"
                    value={data.name}
                    onChange={onChangeInput}
                    name="name"
                    required
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 50 }}
                    fullWidth
                    />  
                
            </MKBox>

             <MKBox >
                <MKInput
                id="desc"
                variant="standard"
                label="Description"
                value={data.desc}
                onChange={onChangeInput}
                name="desc" 
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 250 }}
                fullWidth
                rows={3}
                multiline 
                onKeyDown = {onKeyEnterDown}
                /> 

            </MKBox>
        </MKBox>
        
        <Divider sx={{ my: 0 }} />
        
        <MKBox display="flex" justifyContent="space-between" p={1.5}>

            <MKButton variant="gradient" color="dark" onClick={dismiss}>
                Close
            </MKButton>

            <MKButton variant="gradient" color="primary" onClick={submitGroup}>
                Submit
            </MKButton>

        </MKBox>
        
        
    
    </MKBox>

    )
}

